<template>
<div>
    <div style="max-width: 96%; margin: auto;">
        <fieldset class="fieldset">
        <span v-if="trainingType != 1">
        <h5 class="text-center text-success mt-5">
            <i class="material-icons">check</i> This Event
            has been setup successfully!
        </h5>
    </span>
    <span v-else-if="this.training_status.preassesment_status == 1 && this.training_status.postassesment_status == 1">
        <h5 class="text-center text-success mt-5">
            <i class="material-icons">check</i> This Event
            has been setup successfully!
        </h5>
    </span>
    <span class="mt-3" v-else>
        <h5 class="text-center text-danger">
            This Event is not completed and still
            In-Progress
        </h5>
        <hr />
        <li class="text-success" v-if="this.training_status.preassesment_status == 1">
            <i class="material-icons">check</i> Pre Assessment
            is enabled and being completed.
        </li>
        <li v-else class="text-danger">
            <i class="material-icons">close</i> Pre Assessment
            is not enabled yet.
        </li>
        <li class="text-success" v-if="this.training_status.postassesment_status == 1">
            <i class="material-icons">check</i> Post Assessment
            is enabled and being completed.
        </li>
        <li v-else class="text-danger">
            <i class="material-icons">close</i> Post Assessment
            is not enabled yet.
        </li>
        <li class="text-success" v-if="this.training_status.feedbackstatus == 1">
            <i class="material-icons">check</i> Feedback is
            enabled and being completed.
        </li>
        <li v-else class="text-danger">
            <i class="material-icons">close</i> Feedback is not
            enabled yet.
        </li>
        <hr />
    </span>
    <div class="row mt-3 mb-4 d-flex justify-content-center">
        <button class="btn btn-primary float-right ml-3">
            <router-link :to="{
                                  path:
                                    '/dashboard/advisor/brief_training_report',
                                  query: { trainingId: this.trainingCode }
                                }" class="white-text">Brief Event Details
            </router-link>
        </button>

        <button class="btn btn-primary float-right ml-3">
            <router-link :to="{
                                    path:
                                      '/dashboard/advisor/analysis-report',
                                    query: { trainingId: this.trainingCode }
                                  }" class="white-text">Overall Event Analysis</router-link>
        </button>

        <button class="btn btn-primary float-right ml-3">
            <router-link :to="{
                                    path:
                                      '/dashboard/advisor/individual_analysis_report',
                                    query: { trainingId: this.trainingCode }
                                  }" class="white-text">Individual Event Analysis</router-link>
        </button>
        <button class=" btn btn-primary float-right ml-3" @click="getReport">
            Download Event Report
        </button>
    </div>
    <div class="row d-flex justify-content-center mt-4">
                                               
                                               <button class="btn btn-primary float-right ml-3">
                                                   <router-link :to="{
                                                           path:'/dashboard/advisor/trainerFeedBackAdvisor',
                                                           query: { trainingId: this.trainingCode }
                                                               }" 
                                                           class="white-text">Facilitators Feedback 
                                                   </router-link>
                                               </button>
                                              
                                               
                                           </div>
    </fieldset>
    </div>
    <div>

        <template>
            <div style="max-width: 96%; margin: auto; box-shadow: 0 4px 12px rgba(0,0,0,0.2); border-radius: 10px; overflow: hidden; position: relative; text-align: left;">
                <!-- Header -->
                <div style="background-color: #5B92E5; color: white; padding: 16px 20px; font-size: 1.2em; font-weight: bold; position: relative;">
                    <div style="width: 90%;">{{ trainingTitle }}</div>
                    <button @click="copyAllLinks" title="Copy All" style="position: absolute; right: 20px; top: 12px; background: transparent; border: none; cursor: pointer; font-size: 1.2em; color: white;">
                        🗐
                    </button>

                </div>

                <!-- Links -->
                <div style="padding: 16px 20px; background: #fff; display: flex; flex-direction: column; gap: 12px;">
                    <div v-for="link in socialFields" :key="link.label" style="background: #f2f2f2; padding: 12px; border-radius: 8px; overflow: auto;">
                        <div style="font-weight: bold;">
                            {{ link.icon2 }} {{ link.label }}:
                            <button @click="copySingle(link)" style="float: right; background: transparent; border: none; cursor: pointer; font-size: 1.1em; color: #555;">
                                🗐
                            </button>
                        </div>
                        <div style="padding-left: 26px;">{{ link.value }}</div>
                    </div>
                </div>

            </div>

        </template>
    </div>
    <div class="container-fluid mt-1">
        <!-- Image Upload Section -->

        <div class="row">
            <h5 class="image-heading">Group Image</h5>
        </div>
        <div class="card text-center shadow mb-4 p-4">
            <!-- Image preview -->
            <div v-if="imageUrl" class="text-center">
                <img :src="imageUrl" alt="Preview" class="img-fluid rounded shadow border" />
            </div>
            <div v-else class="text-muted">
                <img src="../../../../assets/group-photo-icon.png" class="img-fluid mobile-logo-img mt-2" /> <!-- Group photo icon -->
                <div>No Image Uploaded</div>
            </div>

        </div>

    </div>

</div>
</template>

    
<script>

import axios from "axios";
import {
    downloadTrainingReport,
} from '../../../../utils/DownloadReport';


export default {
    name: "SocialCards",
    data: () => ({
        isSidebar: false,
        trainingCode: "",
        training_status: "",
        trainingTitle: "",
        basepath: process.env.VUE_APP_BASE_PATH,
        trainingType: '',
        trainingId: '',
        Logo: require('@/assets/unodc_logo.png'),
        socialFields: [{
                label: 'X (Twitter)',
                icon: 'fa-brands fa-x-twitter',
                value: '',
                icon2: "🐤"
            },
            {
                label: 'Facebook',
                icon: 'fa-brands fa-facebook-f',
                value: '',
                icon2: "🟦"
            },
            {
                label: 'LinkedIn',
                icon: 'fa-brands fa-linkedin-in',
                value: '',
                icon2: "💼"
            },
            {
                label: 'Instagram',
                icon: 'fa-brands fa-instagram',
                value: '',
                icon2: "📷"
            },

            {
                label: 'Web Story',
                icon: 'fa-solid fa-globe',
                value: '',
                icon2: "🌐"
            }
        ],
        file: null,
        imageUrl: null,

    }),
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.trainingCode = this.$route.query.trainingId;
        this.openLoading();
        axios.get(process.env.VUE_APP_BASE_PATH +
                "/advisor/trainingsingle/get/" +
                this.trainingCode

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.trainingType = response.data?.training?.typetraining_id,
                this.trainingTitle = response.data?.training?.title;
                this.trainingId = response.data.training.id;
                this.socialFields[0].value = response.data?.training?.twitter_link;
                this.socialFields[1].value = response.data?.training?.facebook_link;
                this.socialFields[2].value = response.data?.training?.linkedin_link;
                this.socialFields[3].value = response.data?.training?.insta_link;
                this.socialFields[4].value = response.data?.training?.web_link;
                this.imageUrl = response.data?.training?.training_image? process.env.VUE_APP_BASE_PATH + "/" + response.data?.training?.training_image : null;
                this.training_status = response.data.training;

            });
       
    },
    methods: {

        copySingle(link) {
            const formattedText = `*Event: ${this.trainingTitle}*\n${link.icon2} *${link.label}:*\n${link.value}`;
            navigator.clipboard.writeText(formattedText).then(() => {
                this.toastSuccess(`${link.label} link copied!`);
            });
        },
        copyAllLinks() {
            let formattedText = `*Event: ${this.trainingTitle}*\n\n`;
            formattedText += this.socialFields.map(link =>
                `${link.icon2} *${link.label}:*\n${link.value}`
            ).join('\n\n');

            navigator.clipboard.writeText(formattedText).then(() => {
                this.toastSuccess('All links copied!');
            });
        },
        formattedDate(tdate) {
            const [year, month, day] = tdate.split("-");
            const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const monthIndex = parseInt(month) - 1;
            return `${day}-${monthNames[monthIndex]}-${year}`;
        },

        getReport() {
            downloadTrainingReport([this.trainingId])
        },
      
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
     
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },

    },
    
};
</script>

    <style scoped>
    
    .btn-primary {
      font-size: 14px;
      height: 44px;
      background: #06a6e0;
      color: #ffffff;
      font-weight: 500;
      border-radius: 5px
    }
    .white-text {
      color: #ffffff;
    }
    .btn-primary:hover {
      background: #08769e;
    }
    .btn-secondary{
      height: 44px;
      font-size: 14px;
      font-weight: 500;
      border-radius: 5px
    }
    .btn-info{
       height: 50px;
      font-size: 14px;
      font-weight: 500;
      border-radius: 5px
    }
  
    #grad1 {
      background-color: #fff;
    }
   
    select.list-dt {
      border: none;
      outline: 0;
      border-bottom: 1px solid #ccc;
      padding: 2px 5px 3px 5px;
      margin: 2px;
    }

    select.list-dt:focus {
      border-bottom: 2px solid skyblue;
    }

    .card {
      z-index: 0;
      border: none;
      border-radius: 0.5rem;
      position: relative;
    }

    .fs-title {
      font-size: 25px;
      color: #2c3e50;
      margin-bottom: 10px;
      font-weight: bold;
      text-align: left;
    }
    .radio-group {
      position: relative;
      margin-bottom: 25px;
    }

    .radio {
      display: inline-block;
      width: 204;
      height: 104;
      border-radius: 0;
      background: lightblue;
      box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
      box-sizing: border-box;
      cursor: pointer;
      margin: 8px 2px;
    }

    .radio:hover {
      box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
    }

    .radio.selected {
      box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
    }

    .fit-image {
      width: 100%;
      object-fit: cover;
    }

       
        /* Socila links */
    .social-card {
      border-radius: 15px;
      border: 1px solid #06a6e0;
      height: 150px;
    }

    .social-icon {
      font-size: 36px;
      color: #06a6e0;
    }
    .image-heading{
      font-size: 30px;
      font-weight: 600;
      color: #06a6e0; 
      font-family: 'Poppins', sans-serif;
      margin-left: 20px;
    }
    .form-control{
      line-height: 1;
    }
    .card-text{
        overflow: hidden;
    }
    .fieldset {
    background: #e8e8e8;
    padding: 20px 40px 30px 40px;
    border: 2px solid #ccc;
    border-radius: 16px;
    margin-bottom: 20px;
}
    </style>
